module.exports = __webpack_public_path__ + "img/gallery10.89997a83.jpg";